import { render, staticRenderFns } from "./RankScroll.vue?vue&type=template&id=bcde84ac&scoped=true&"
import script from "./RankScroll.vue?vue&type=script&lang=js&"
export * from "./RankScroll.vue?vue&type=script&lang=js&"
import style0 from "./RankScroll.vue?vue&type=style&index=0&id=bcde84ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcde84ac",
  null
  
)

export default component.exports